import { render } from "./Alert.vue?vue&type=template&id=48a9a4b6"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v1/Modal/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48a9a4b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48a9a4b6', __exports__)) {
    api.reload('48a9a4b6', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=48a9a4b6", () => {
    api.rerender('48a9a4b6', render)
  })

}


export default __exports__